export default "<div class=\"outer-error primary-color\">\n    <router-outlet></router-outlet>\n</div>";